import { useMemo } from "react"

import _ from "lodash"

import {
    Layer,
    MapStyles,
    ROAD_SPEEDINGS_LAYER,
    ROAD_SPEEDINGS_SOURCE,
    useMapStateContext,
    useOrderingLayers,
} from "@l2r-front/l2r-map"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { useTheme } from "@l2r-front/l2r-ui"

import { useSpeedingsStateContext } from "../../contexts/SpeedingsContext"
import { getRoadSpeedingsLayerStyle } from "../../utils/getSpeedingsConfig"

import { RoadSpeedingsSource } from "../RoadSpeedingsSource"

export function RoadSpeedingsLayer(props) {
    const { road } = props

    const { selectedLinearLocations } = useNetworksStateContext()
    const { currentMapStyle } = useMapStateContext()
    const { currentActiveLayer } = useSpeedingsStateContext()
    const theme = useTheme()

    const speedingsLayerConfig = useMemo(() => {
        const selectedRoad = selectedLinearLocations?.[0]?.road
        const referentialColor = currentMapStyle === MapStyles.plan ? theme.palette.map.darkReferential : theme.palette.map.lightReferential
        return getRoadSpeedingsLayerStyle(referentialColor, theme, selectedRoad, currentActiveLayer)
    }, [currentMapStyle, theme, selectedLinearLocations, currentActiveLayer])

    useOrderingLayers([ROAD_SPEEDINGS_LAYER])

    return (
        <RoadSpeedingsSource
            id={ROAD_SPEEDINGS_SOURCE}
            tolerance={.001}
            road={road}
        >
            <Layer
                id={ROAD_SPEEDINGS_LAYER}
                {...speedingsLayerConfig}
            />
        </RoadSpeedingsSource>
    )
}
